export const paths = {
  home: "/",
  services: "/services",
  faq: "/faq",
  contact: "/contact",
};
